/* RESPONSIBLE TEAM: team-frontend-tech */
import Predicate from 'predicates/models/predicate';
export default Predicate.extend({
  isEditable: true,
  genericType: 'surveyDropdownQuestion',
  defaultComparison: 'eq',
  getDefaultValue() {
    return undefined;
  }
});